module.exports = __webpack_public_path__ + "magnet_logo.png?1e60a12b6a5fdf581c5dc7be00c4071a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/magnet_logo.png
// module id = 636
// module chunks = 0